import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import { decodeJWT } from '../utils/decodeToken';

import moment from 'moment';
import 'moment/locale/es';

export const LoggedOutGuard = () => {

    const token = useSelector( (state: any) => state.auth.tokenAccess);
    let sessionExpired = true;

    if( token ){

        const data = decodeJWT(token);
        const currentMoment = moment();
        const tokenExpiration = new Date(data?.exp * 1000);
        sessionExpired = moment(currentMoment).isAfter(tokenExpiration);
        
    }
    
    return (!token || sessionExpired) ? <Outlet /> : <Navigate replace to={'/dashboard/inicio'} />;

};

export default LoggedOutGuard;